import ReactDOM from 'react-dom/client';
import ChildrenCarousel from './ChildrenCarousel';

window.initChildrenCarousel = (title, posts, allLink) => {
  const root = ReactDOM.createRoot(document.getElementById('children-carousel'));
  root.render(<ChildrenCarousel title={title} posts={posts} allLink={allLink} />);
}
